<template>
  <section class="viewsrhqyBasicManage_serviceList p-4 space-y-4">
    <viewTitle
      title="业务管理 / 基础数据管理 / 车辆业务类型管理"
      :showReturn="false"
    />
    <div class="mb-4 flex items-center">
      <el-button v-has="['c-base-mp-carBusiness-add']" @click="onAdd" size="medium" type="primary">添加</el-button>
      <el-button v-has="['c-base-mp-carBusiness-import']" @click="showImport = true" size="medium">导入</el-button>
      <el-button v-has="['c-base-mp-carBusiness-export']" @click="onExport" size="medium">导出</el-button>
      <el-button v-has="['c-base-mp-carBusiness-delete']" @click="onDelete" size="medium">删除</el-button>
      <!-- 无环保总开关权限时，隐藏完整配置块，避免暴露当前配置状态。 -->
      <div v-if="canManageVehicleEmissionGlobal" class="ml-8 flex items-center">
        <span class="mr-3 text-sm">环保排放校验总开关</span>
        <el-switch
          v-model="vehicleEmissionGlobalEnabled"
          :active-value="1"
          :inactive-value="0"
          active-text="开启"
          inactive-text="关闭"
          :disabled="vehicleEmissionGlobalSaving"
          @change="onVehicleEmissionGlobalChange"
        ></el-switch>
      </div>
    </div>
    <div class="space-x-2">
      <span class="text-sm">关键字</span>
      <el-input
        v-model="queryParam.keyword"
        clearable
        placeholder="输入关键字搜索"
        class="w-60"
      ></el-input>
    </div>
    <c-table
      class="mt-4"
      isSelection
      :selection.sync="rowKeySelection"
      :isIndex="false"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      @loadPage="loadData"
    >
      <template slot="update_time" slot-scope="scope">
        {{ scope.row.update_time | timeFormat }}
      </template>
      <template slot="action" slot-scope="scope">
        <el-row type="flex" justify="space-around" align="middle">
          <c-link v-has="['c-base-mp-carBusiness-update']" @click="onEdit(scope.row)" label="修改"></c-link>
          <c-link
            @click="onDelete(scope.row, 1)"
            v-has="['c-base-mp-carBusiness-delete']"
            label="删除"
            type="danger"
          ></c-link>
          <c-link
            v-if="scope.row.state == 2"
            @click="onEnable(scope.row)"
            v-has="['c-base-mp-carBusiness-switch']"
            label="启用"
            type="success"
          ></c-link>
          <c-link
            v-if="scope.row.state == 1"
            @click="onEnable(scope.row)"
            v-has="['c-base-mp-carBusiness-switch']"
            label="禁用"
            type="warning"
          ></c-link>
        </el-row>
      </template>
    </c-table>
    <c-import
      v-bind="importOptions"
      :show.sync="showImport"
      @finish="refreshData"
    >
      <span slot="desc">
        <span>
          3、仅支持模板信息格式，请勿填写其他数据内容
        </span>
        <br />
      </span>
    </c-import>
    <businessModal ref="businessModal" @ok="refreshData" />
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import businessModal from "./components/businessModal.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      importOptions: {
        downloadDemoName: "车辆业务类型导入模板",
        templateUrl: "/api/queue/admin/download_template?file_name=import_car_business.xlsx",
        importUrl: "/api/queue/admin/import_car_business",
      },
      showImport: false,
      vehicleEmissionGlobalEnabled: 0,
      vehicleEmissionGlobalSaving: false,
      queryParam: {
        keyword: "", // 关键字搜索
        state: 0, // 状态
        is_parent: 1 // 是否是父级
      },
      columns: [
        {
          label: "基地",
          prop: "baseName",
          formatData: () => this.baseInfo.com_name
        },
        { label: "预约业务名称", prop: "p_name" },
        { label: "车辆业务类型代码", prop: "code" },
        { label: "车辆业务类型", prop: "name" },
        {
          width: 120,
          label: "环保排放校验",
          prop: "emission_limit",
          formatData: row => {
            return Number(row.emission_limit) === 1 ? "开启" : "关闭";
          }
        },
        {
          width: 120,
          label: "SAP校验",
          prop: "is_sap_check",
          formatData: row => {
            return row.is_sap_check == 1 ? "是" : "否";
          }
        },
        {
          width: 120,
          label: "需要送货单号",
          prop: "is_delivery_code",
          formatData: row => {
            return row.is_delivery_code == 1 ? "是" : "否";
          }
        },
        {
          width: 140,
          label: "允许先卸后取样",
          prop: "allow_unload_before_sampling",
          formatData: row => {
            return Number(row.allow_unload_before_sampling) === 1 ? "是" : "否";
          }
        },
        {
          width: 80,
          label: "状态",
          prop: "state",
          formatData: row => {
            return row.state == 1 ? "启用" : "禁用";
          }
        },
        { width: 180, label: "最近维护时间", prop: "update_time" },
        { label: "操作", prop: "action", width: 160 }
      ],
      fetchDataEvent: params =>
        this.$common.http({
          url: "/api/queue/admin/query_business",
          data: params
        }),
      deleteConfig: {
        title: "删除", // 标题
        content: "确认删除车辆预约业务？删除后数据将不可恢复！",
        url: "/api/queue/admin/delete_business"
      },
      exportDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/export_car_business",
          data: {},
          noLoading: true
        })
      }
    };
  },
  components: {
    businessModal
  },
  computed: {
    ...mapGetters(["baseInfo"]),
    canManageVehicleEmissionGlobal() {
      const keys = this.$store.state.privilegeConfig.keys || [];
      return keys.includes("c-base-mp-carBusiness-emGlobal");
    }
  },
  mixins: [initListMinxin, mixinTableLyout],
  created() {
    this.loadVehicleEmissionGlobalSwitch();
  },
  methods: {
    async loadVehicleEmissionGlobalSwitch() {
      try {
        const response = await this.$common.http({
          url: "/api/queue/admin/query_vehicle_emission_global_switch"
        });
        this.vehicleEmissionGlobalEnabled =
          Number(response.data.data.global_enabled) === 1 ? 1 : 0;
      } catch (error) {}
    },
    async onVehicleEmissionGlobalChange(value) {
      const previousValue = Number(value) === 1 ? 0 : 1;
      this.vehicleEmissionGlobalSaving = true;
      try {
        await this.$common.http({
          url: "/api/queue/admin/save_vehicle_emission_global_switch",
          data: { global_enabled: Number(value) === 1 ? 1 : 0 }
        });
        this.$common.pcToastSuccess("操作成功");
      } catch (error) {
        this.vehicleEmissionGlobalEnabled = previousValue;
      } finally {
        this.vehicleEmissionGlobalSaving = false;
      }
    },
    onAdd() {
      this.$refs.businessModal.openModal();
    },
    onEdit(row) {
      this.$refs.businessModal.openModal(row);
    },
    onEnable(row) {
      this.$confirm("确认禁用车辆预约业务？", "提示").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/enable_business",
            data: { id: row.id }
          });
          this.$common.pcToastSuccess(`操作成功`);
          this.onSearch();
        } catch (error) {}
      });
    }
  }
};
</script>
